module.exports = __webpack_public_path__ + "static/if-the-universe-is-teeming-with-aliens--where-is-everybody-da0e51f0c71bb8c11c242fc27305d416.jpg";